export const LOCALES_AVAILABLE = ['en', 'it'];
export const DEFAULT_LOCALE = 'en';
